module.exports = __webpack_public_path__ + "78a24edf241782cb6dd65fe8fd4eb329.png";